<div class="flex flex-col md:justify-between">
  <div class="w-full md:ml-4 mx-auto my-auto bg-white rounded-full h-10 items-center flex md:p-6 lg:w-56">
    <img src="assets/svg/search.svg" class="h-4 mx-4" />
    <input class="appearance-none focus:outline-none bg-transparent text-sm text-zambezi w-full" type="text"
      placeholder="Recherche" matInput [matAutocomplete]="auto" [formControl]="searchCtrl" />
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let item of dataset | async" (click)="search(item.url)" [value]="item.keyword">
        <div class="flex items-center lg:text-md text-sm">
          <div>{{ item.keyword }}</div>
        </div>
      </mat-option>
    </mat-autocomplete>
  </div>
</div>